/* Generado desde docs/mini-prixia/prototipos/04-dos-logos-3d.html (DATOS). No editar a mano. */

/** De cada punto del rombo: x e y (alto 1, centrado en 0), radio y lugar en el degradado (0 a 1). */
export const PUNTOS: ReadonlyArray<readonly [number, number, number, number]> = [
  [0.0285, 0.5, 0.0114, 0.008],
  [-0.0283, 0.4587, 0.0125, 0.059],
  [0.0827, 0.446, 0.0096, 0.052],
  [0.0025, 0.4137, 0.0145, 0.098],
  [-0.0871, 0.4023, 0.0116, 0.125],
  [0.0494, 0.3995, 0.0146, 0.104],
  [0.1392, 0.3904, 0.0111, 0.097],
  [-0.0402, 0.3676, 0.0157, 0.151],
  [0.0956, 0.3537, 0.0156, 0.141],
  [-0.1416, 0.3452, 0.0113, 0.191],
  [0.0054, 0.3298, 0.0175, 0.18],
  [0.1943, 0.3346, 0.0111, 0.143],
  [-0.0877, 0.3181, 0.0148, 0.208],
  [0.056, 0.308, 0.0152, 0.193],
  [0.1404, 0.3075, 0.0145, 0.179],
  [-0.2004, 0.2924, 0.0099, 0.253],
  [-0.0448, 0.2797, 0.0165, 0.239],
  [-0.1375, 0.2717, 0.0148, 0.263],
  [0.2527, 0.2759, 0.0107, 0.191],
  [0.11, 0.2551, 0.0189, 0.236],
  [0.1885, 0.2612, 0.0148, 0.216],
  [0.0303, 0.2422, 0.0209, 0.263],
  [-0.0945, 0.227, 0.0171, 0.299],
  [-0.2556, 0.2339, 0.011, 0.321],
  [-0.1822, 0.2262, 0.0145, 0.316],
  [0.308, 0.221, 0.0103, 0.235],
  [0.2338, 0.216, 0.0137, 0.253],
  [-0.029, 0.206, 0.019, 0.309],
  [0.1595, 0.2051, 0.017, 0.277],
  [0.0853, 0.1864, 0.0197, 0.308],
  [-0.2283, 0.1801, 0.0156, 0.369],
  [-0.15, 0.1771, 0.0173, 0.359],
  [-0.3129, 0.1795, 0.0114, 0.385],
  [0.0287, 0.1522, 0.0359, 0.352],
  [0.2785, 0.1684, 0.0145, 0.292],
  [0.365, 0.1658, 0.0094, 0.28],
  [0.2108, 0.1536, 0.0176, 0.319],
  [-0.086, 0.1478, 0.0203, 0.376],
  [0.1428, 0.1323, 0.0186, 0.352],
  [-0.2752, 0.1351, 0.0141, 0.422],
  [-0.2011, 0.1263, 0.0179, 0.418],
  [0.3247, 0.1229, 0.0135, 0.329],
  [-0.3673, 0.119, 0.0114, 0.454],
  [0.2615, 0.103, 0.0171, 0.36],
  [0.4207, 0.1057, 0.0119, 0.33],
  [-0.1427, 0.0927, 0.0205, 0.441],
  [-0.3208, 0.0904, 0.0145, 0.474],
  [0.1151, 0.0704, 0.036, 0.418],
  [0.1969, 0.0763, 0.0195, 0.398],
  [-0.2504, 0.0738, 0.0164, 0.478],
  [0.3727, 0.0762, 0.0146, 0.367],
  [-0.4263, 0.0648, 0.0111, 0.518],
  [0.3164, 0.0491, 0.0191, 0.404],
  [0.4788, 0.0511, 0.0103, 0.374],
  [-0.3635, 0.0443, 0.0157, 0.527],
  [-0.1981, 0.0369, 0.0203, 0.506],
  [-0.0441, 0.0087, 0.0377, 0.507],
  [0.4189, 0.0304, 0.0156, 0.405],
  [-0.1319, 0.0147, 0.0338, 0.516],
  [-0.3005, 0.0239, 0.0157, 0.536],
  [0.2553, 0.0197, 0.0193, 0.444],
  [0.1638, -0.0084, 0.0333, 0.487],
  [-0.4788, 0.0072, 0.0122, 0.584],
  [0.3567, -0.0031, 0.0178, 0.448],
  [-0.3955, -0.0051, 0.0151, 0.582],
  [-0.2062, -0.0211, 0.0202, 0.564],
  [0.4229, -0.0156, 0.013, 0.449],
  [-0.2896, -0.0288, 0.0182, 0.587],
  [0.2294, -0.0404, 0.0202, 0.508],
  [0.0155, -0.0533, 0.0361, 0.558],
  [0.3082, -0.0525, 0.0193, 0.506],
  [-0.4299, -0.0462, 0.0119, 0.628],
  [-0.3456, -0.0497, 0.0153, 0.617],
  [-0.062, -0.0725, 0.0369, 0.59],
  [0.3774, -0.0622, 0.0153, 0.503],
  [0.4576, -0.0604, 0.0109, 0.488],
  [-0.148, -0.0807, 0.023, 0.613],
  [0.0808, -0.0915, 0.0322, 0.584],
  [-0.2381, -0.0787, 0.0173, 0.627],
  [0.1746, -0.0934, 0.0202, 0.57],
  [-0.3033, -0.0937, 0.0156, 0.653],
  [0.2555, -0.1029, 0.0189, 0.565],
  [-0.3765, -0.1036, 0.0097, 0.676],
  [0.3303, -0.1065, 0.0154, 0.555],
  [0.4007, -0.1184, 0.0109, 0.555],
  [-0.1835, -0.1323, 0.0181, 0.67],
  [-0.0934, -0.1352, 0.0197, 0.658],
  [0.0221, -0.152, 0.0311, 0.654],
  [-0.2577, -0.1432, 0.0156, 0.694],
  [0.1184, -0.1495, 0.0198, 0.635],
  [0.2031, -0.1549, 0.0164, 0.625],
  [0.287, -0.1527, 0.0151, 0.609],
  [-0.3175, -0.1578, 0.0119, 0.719],
  [0.3439, -0.1757, 0.0116, 0.621],
  [-0.1335, -0.183, 0.0164, 0.712],
  [-0.0369, -0.1909, 0.0203, 0.703],
  [-0.2079, -0.1923, 0.0162, 0.734],
  [0.0607, -0.2076, 0.0209, 0.702],
  [0.1523, -0.2041, 0.0186, 0.683],
  [0.2365, -0.2003, 0.0135, 0.665],
  [-0.2625, -0.217, 0.0111, 0.768],
  [-0.0843, -0.2354, 0.0196, 0.755],
  [-0.166, -0.2334, 0.0143, 0.767],
  [0.2892, -0.2321, 0.0107, 0.687],
  [0.0188, -0.2472, 0.0206, 0.749],
  [0.192, -0.2481, 0.0146, 0.72],
  [0.1028, -0.2586, 0.0195, 0.746],
  [-0.2074, -0.2728, 0.0111, 0.814],
  [-0.1179, -0.2801, 0.0131, 0.805],
  [-0.0336, -0.2864, 0.018, 0.797],
  [0.2307, -0.2856, 0.0099, 0.75],
  [0.1452, -0.291, 0.014, 0.77],
  [0.0499, -0.3065, 0.0176, 0.802],
  [-0.0738, -0.329, 0.0158, 0.846],
  [-0.1479, -0.3327, 0.0114, 0.863],
  [0.0197, -0.3381, 0.0167, 0.839],
  [0.0991, -0.3388, 0.0131, 0.826],
  [0.1776, -0.3455, 0.0122, 0.818],
  [-0.0223, -0.373, 0.0153, 0.881],
  [0.0541, -0.3855, 0.0153, 0.88],
  [-0.0936, -0.3867, 0.0096, 0.907],
  [0.1181, -0.3985, 0.0114, 0.881],
  [0.02, -0.417, 0.0156, 0.917],
  [-0.0372, -0.4423, 0.0111, 0.952],
  [0.0637, -0.459, 0.0114, 0.951],
  [0.0212, -0.5, 0.0119, 0.999],
  [0.0194, 0.0419, 0.0416, 0.463],
  [-0.0345, 0.0492, 0.0269, 0.465],
  [0.0733, 0.0345, 0.0269, 0.461],
  [0.0243, 0.0958, 0.0269, 0.409],
  [0.0145, -0.012, 0.0269, 0.517],
];
